import React, { useEffect, useState } from "react";
import DataProvider from "../../apis";
import moment from "moment";
import ApptCalendar from "../../components/card/appt-calendar";
import RecentAppts from "../../components/card/recent-appts";
import AppointmentList from "../../components/sections/appointment-list";
import LoadWrapper from "../../components/elements/load-wrapper";

export default function Appointments() {
  const [date, setDate] = useState<Date>(new Date());
  const [data, setData] = useState<any[] | null>(null);
  const [loading, setLoading] = useState(false);

  async function getAllAppt(params?: Date) {
    setLoading(true);
    try {
      const results = await DataProvider.getAllAppointment(1, 200);
      const filter = results.data.appointments.filter(
        (item: any) =>
          moment(item.date, "DD-MM-YYYY").format("MMM DD YYYY") ===
          moment(params).format("MMM DD YYYY")
      );
      setData(filter);
      setLoading(false);
    } catch (error: unknown) {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (date) {
      getAllAppt(date);
    }
  }, [date]);

  return (
    <div className="min-h-full bg-medpharma-mist/40">
      <header className="mb-6">
        <h1 className="text-3xl font-bold text-medpharma-slate tracking-tight">
          Appointments
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Manage your schedule and view upcoming consultations
        </p>
      </header>

      <section
        className="grid lg:grid-cols-2 grid-cols-1 gap-6 mb-8"
        aria-label="Calendar and daily appointments"
      >
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-card-hover overflow-hidden">
          <ApptCalendar setDate={setDate} date={date} />
        </div>
        <div className="bg-white rounded-2xl border border-slate-200/80 shadow-card-hover overflow-hidden">
          <LoadWrapper loading={loading}>
            <RecentAppts
              setDate={setDate}
              date={date}
              data={data}
              loading={loading}
            />
          </LoadWrapper>
        </div>
      </section>

      <section aria-label="All appointments">
        <AppointmentList />
      </section>
    </div>
  );
}
